.warning {
	color: var(--ds-text-danger, var(--adg3-color-R300));
}
